export default "__VITE_ASSET__07b5fd0e__"